import { ref } from 'vue'
import { useAxiosCreate } from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header';


class ApiConnector{

	constructor(model) {
    	this.api = useAxiosCreate(model);
  	}

	post(link,{form,params}){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.post(link,JSON.stringify(form),{params,headers: authHeader()})
			response.value = res.data
		}
		return {response,request};
	}

	get(link,{params}){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.get(link,{params,headers: authHeader()})
			response.value = res.data
		}
		return {response,request}
	}

	getBlob(link,{params} = {}){
		const request = async ()=>{
			return await this.api.get(link,{params,headers: authHeader(),responseType: 'blob'})
		}
		return request()
	}

	put(id,form){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.put(id.toString(),JSON.stringify(form),{headers: authHeader()})
			response.value = res.data
		}
		return {response,request};
	}

	putFromLink(link,form={}){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.put(link,JSON.stringify(form),{headers: authHeader()})
			response.value = res.data
		}
		return {response,request};
	}

	delete(id,params){
		const response = ref()
		const request = async ()=>{
			const res = await this.api.delete(id.toString(),{params,headers: authHeader()})
			response.value = res.data
		}
		return {response,request};
	}

	getFile(link,form){
		const request = async ()=>{
			const res = await this.api.post(link,form,{headers: authHeader(),responseType: 'blob'})
			return res
		}
		return request()
	}

	addSignature(link,file){
		const formData = new FormData();
    	formData.append('file', file);

		const response = ref()
		const request = async ()=>{
			const res = await this.api.post(link,formData,{
				 headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			response.value = res.data
		}
		return {response,request}
	}

}


export default ApiConnector
